import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["dir"]
const _hoisted_2 = { class: "max-w-7xl mx-auto" }
const _hoisted_3 = { class: "bg-white/80 dark:bg-[#1a1a1a]/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 dark:border-[#374151]/50 overflow-hidden" }
const _hoisted_4 = { class: "bg-gradient-to-r from-[#667eea] to-[#764ba2] p-6" }
const _hoisted_5 = { class: "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" }
const _hoisted_6 = { class: "flex-1 w-full sm:w-auto" }
const _hoisted_7 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_8 = { class: "text-xl font-bold text-white" }
const _hoisted_9 = { class: "text-white/80 text-sm" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "w-full sm:w-auto" }
const _hoisted_12 = { class: "p-6" }
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-20"
}
const _hoisted_14 = { class: "mt-4 text-base font-medium text-[#667eea]" }
const _hoisted_15 = {
  key: 1,
  class: "bg-red-50/80 dark:bg-red-900/20 backdrop-blur-xl rounded-2xl shadow-lg border border-red-200/50 dark:border-red-800/30 p-6 mb-6"
}
const _hoisted_16 = { class: "flex items-start gap-4" }
const _hoisted_17 = { class: "text-lg font-semibold text-red-700 dark:text-red-400" }
const _hoisted_18 = { class: "text-red-600 dark:text-red-300 mt-1" }
const _hoisted_19 = {
  key: 2,
  class: "text-center py-16"
}
const _hoisted_20 = { class: "text-lg font-semibold text-gray-700 mb-2" }
const _hoisted_21 = { class: "text-gray-500" }
const _hoisted_22 = {
  key: 3,
  class: "overflow-hidden rounded-2xl border border-gray-200/50 dark:border-gray-700/50"
}
const _hoisted_23 = { class: "overflow-x-auto" }
const _hoisted_24 = { class: "w-full" }
const _hoisted_25 = { class: "bg-gradient-to-r from-gray-50 to-gray-100 dark:from-[#1e293b] dark:to-[#334155]" }
const _hoisted_26 = { class: "ltr:text-left rtl:text-right px-6 py-4 font-semibold text-gray-700 dark:text-gray-200 text-sm ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }
const _hoisted_27 = { class: "ltr:text-left rtl:text-right px-6 py-4 font-semibold text-gray-700 dark:text-gray-200 text-sm" }
const _hoisted_28 = { class: "ltr:text-left rtl:text-right px-6 py-4 font-semibold text-gray-700 dark:text-gray-200 text-sm" }
const _hoisted_29 = { class: "ltr:text-left rtl:text-right px-6 py-4 font-semibold text-gray-700 dark:text-gray-200 text-sm" }
const _hoisted_30 = { class: "ltr:text-left rtl:text-right px-6 py-4 font-semibold text-gray-700 dark:text-gray-200 text-sm" }
const _hoisted_31 = { class: "ltr:text-left rtl:text-right px-6 py-4 font-semibold text-gray-700 dark:text-gray-200 text-sm ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }
const _hoisted_32 = { class: "bg-white dark:bg-[#1a1a1a] divide-y divide-gray-100 dark:divide-gray-700/50" }
const _hoisted_33 = { class: "px-6 py-4 ltr:text-left rtl:text-right ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_34 = { class: "flex ltr:justify-start rtl:justify-end" }
const _hoisted_35 = { class: "w-12 h-12 rounded-xl overflow-hidden border-2 border-white shadow-md" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "px-6 py-4 ltr:text-left rtl:text-right" }
const _hoisted_38 = { class: "ltr:text-left rtl:text-right" }
const _hoisted_39 = { class: "text-xs text-gray-500 dark:text-gray-400 block" }
const _hoisted_40 = { class: "px-6 py-4 ltr:text-left rtl:text-right" }
const _hoisted_41 = { class: "flex ltr:justify-start rtl:justify-end" }
const _hoisted_42 = { class: "inline-flex items-center px-3 py-1 rounded-full bg-gradient-to-r from-blue-50 to-blue-100 text-blue-600 text-xs font-medium border border-blue-200" }
const _hoisted_43 = { class: "px-6 py-4 ltr:text-left rtl:text-right" }
const _hoisted_44 = { class: "font-semibold text-gray-900 dark:text-white text-sm" }
const _hoisted_45 = { class: "px-6 py-4 ltr:text-left rtl:text-right" }
const _hoisted_46 = { class: "font-semibold text-gray-900 dark:text-white text-sm" }
const _hoisted_47 = { class: "px-6 py-4 ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_48 = { class: "flex items-center ltr:justify-start rtl:justify-end gap-3" }
const _hoisted_49 = {
  key: 4,
  class: "mt-6 bg-gradient-to-r from-gray-50 to-gray-100 dark:from-[#1e293b] dark:to-[#334155] rounded-2xl p-4"
}
const _hoisted_50 = { class: "flex items-center justify-between text-sm" }
const _hoisted_51 = { class: "text-gray-600 dark:text-gray-300" }
const _hoisted_52 = { class: "flex items-center gap-4" }
const _hoisted_53 = { class: "text-gray-600 dark:text-gray-300" }
const _hoisted_54 = { class: "inline-flex items-center px-3 py-1 rounded-full bg-gradient-to-r from-[#667eea] to-[#764ba2] text-white text-xs font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: "min-h-screen bg-gradient-to-br from-[#FAFBFF] via-[#F8FAFF] to-[#F0F7FF] dark:from-[#0a0a0a] dark:to-[#1a1a1a] p-6",
    dir: _ctx.isRtl ? 'rtl' : 'ltr'
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-white text-xl" }, "inventory_2")
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.directT('ecommerce.productsList.title')), 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.directT('ecommerce.productsList.subtitle')), 1)
                ])
              ]),
              _createElementVNode("form", {
                class: "relative max-w-md",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fetchProducts && _ctx.fetchProducts(...args)), ["prevent"]))
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute left-4 top-1/2 -translate-y-1/2 text-white/80" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-lg" }, "search")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchProducts && _ctx.fetchProducts(...args))),
                  placeholder: _ctx.directT('ecommerce.productsList.searchHere'),
                  class: "w-full h-12 rounded-xl bg-white/20 border border-white/30 text-white placeholder-white/70 pl-12 pr-4 text-sm outline-none focus:border-white focus:ring-2 focus:ring-white/20 transition-all duration-300 backdrop-blur-sm"
                }, null, 40, _hoisted_10), [
                  [_vModelText, _ctx.searchQuery]
                ])
              ], 32)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.navigateToCreateProduct && _ctx.navigateToCreateProduct(...args))),
                class: "group w-full sm:w-auto inline-flex items-center justify-center gap-3 px-6 py-3 bg-white/20 text-white font-semibold rounded-xl hover:bg-white/30 transition-all duration-300 backdrop-blur-sm border border-white/30 hover:border-white/50 transform hover:scale-105"
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-5 h-5 rounded-lg bg-white/20 flex items-center justify-center" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "add")
                ], -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.directT('ecommerce.productsList.addNewProduct')), 1),
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "material-symbols-outlined text-sm group-hover:translate-x-1 transition-transform duration-300" }, "arrow_forward", -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "relative" }, [
                  _createElementVNode("div", { class: "w-12 h-12 border-4 border-[#667eea]/20 border-t-[#667eea] rounded-full animate-spin" }),
                  _createElementVNode("div", {
                    class: "absolute inset-0 w-12 h-12 border-4 border-transparent border-r-[#764ba2] rounded-full animate-spin",
                    style: {"animation-delay":"-0.5s"}
                  })
                ], -1)),
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.directT('ecommerce.productsList.loadingProducts')), 1)
              ]))
            : (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "w-10 h-10 bg-red-500/10 rounded-xl flex items-center justify-center" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-red-500 text-xl" }, "error")
                    ], -1)),
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.directT('ecommerce.productsList.errorLoadingProducts')), 1),
                      _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.error), 1)
                    ])
                  ])
                ]))
              : (_ctx.products.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "w-16 h-16 bg-gradient-to-r from-gray-100 to-gray-200 rounded-2xl flex items-center justify-center mx-auto mb-4" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-2xl" }, "inventory_2")
                    ], -1)),
                    _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.directT('ecommerce.productsList.noProductsFound')), 1),
                    _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.directT('ecommerce.productsList.noProductsFound')), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("table", _hoisted_24, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_25, [
                            _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.directT('ecommerce.productsList.image')), 1),
                            _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.directT('ecommerce.productsList.product')), 1),
                            _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.directT('ecommerce.productsList.category')), 1),
                            _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.directT('ecommerce.productsList.price')), 1),
                            _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.directT('ecommerce.productsList.amount')), 1),
                            _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.directT('ecommerce.productsList.actions')), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: product.id,
                              class: "hover:bg-gradient-to-r hover:from-[#667eea]/5 hover:to-[#764ba2]/5 transition-all duration-300 group"
                            }, [
                              _createElementVNode("td", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("img", {
                                      src: product.image_link || require('@/assets/images/products/product1.jpg'),
                                      class: "w-full h-full object-cover group-hover:scale-110 transition-transform duration-300",
                                      alt: "product-image"
                                    }, null, 8, _hoisted_36)
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _createVNode(_component_RouterLink, {
                                    to: `/ecommerce/edit-product?id=${product.id}`,
                                    class: "font-semibold text-gray-900 dark:text-white hover:text-[#667eea] transition-colors duration-200 text-sm block mb-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(product.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]),
                                  _createElementVNode("span", _hoisted_39, _toDisplayString(product.published_at ? new Date(product.published_at).toLocaleDateString() : _ctx.directT('ecommerce.productsList.draft')), 1)
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_40, [
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("span", _hoisted_42, _toDisplayString(product.category || _ctx.directT('ecommerce.productsList.uncategorized')), 1)
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_43, [
                                _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.formatPrice(product.price)), 1)
                              ]),
                              _createElementVNode("td", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.formatPrice(product.compare_at_price)), 1)
                              ]),
                              _createElementVNode("td", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                  _createVNode(_component_RouterLink, {
                                    to: `/ecommerce/edit-product?id=${product.id}`,
                                    class: "group relative w-10 h-10 bg-gradient-to-br from-[#667eea] to-[#764ba2] rounded-xl flex items-center justify-center text-white shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300 hover:-translate-y-1"
                                  }, {
                                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                                      _createElementVNode("i", { class: "material-symbols-outlined text-base font-medium" }, "edit_note", -1),
                                      _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" }, null, -1)
                                    ])),
                                    _: 2,
                                    __: [11]
                                  }, 1032, ["to"]),
                                  _cache[12] || (_cache[12] = _createStaticVNode("<button class=\"group relative w-10 h-10 bg-gradient-to-br from-[#4facfe] to-[#00f2fe] rounded-xl flex items-center justify-center text-white shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300 hover:-translate-y-1\"><i class=\"material-symbols-outlined text-base font-medium\">visibility</i><div class=\"absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300\"></div></button><button type=\"button\" class=\"group relative w-10 h-10 bg-gradient-to-br from-[#ff6b6b] to-[#ee5a52] rounded-xl flex items-center justify-center text-white shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300 hover:-translate-y-1\"><i class=\"material-symbols-outlined text-base font-medium\">delete_forever</i><div class=\"absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300\"></div></button><button class=\"group relative w-10 h-10 bg-gradient-to-br from-[#a8edea] to-[#fed6e3] rounded-xl flex items-center justify-center text-gray-600 shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300 hover:-translate-y-1\"><i class=\"material-symbols-outlined text-base font-medium\">content_copy</i><div class=\"absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300\"></div></button>", 3))
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])),
          (_ctx.products.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.directT('ecommerce.productsList.showingProducts', { count: _ctx.products.length })), 1),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.directT('ecommerce.productsList.totalProducts')), 1),
                    _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.products.length), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}